import BrandSymbol from '@brand-icon';

export default function IExameLogo({ size = 28, variant = 'horizontal', color = 'var(--midnight)', accent = 'var(--brand-primary)' }) {
  const symbol = <BrandSymbol size={size} color={color} accent={accent} />;

  if (variant === 'symbol') return symbol;

  if (variant === 'vertical') {
    return (
      <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
        {symbol}
        <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: size * 0.55, color, letterSpacing: '-0.02em', lineHeight: 1 }}>
          Exame
        </span>
      </div>
    );
  }

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {symbol}
      <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: size * 0.75, color, letterSpacing: '-0.02em', lineHeight: 1, marginLeft: -size * 0.08 }}>
        Exame
      </span>
    </div>
  );
}
